import { type FC, type PropsWithChildren } from "react";

export const Seo: FC<
    PropsWithChildren<{
        title: string;
        description?: string;
    }>
> = ({ title, description, children }) => {
    return (
        <>
            <title>{title}</title>
            <meta name="description" content={description} />
            {children}
        </>
    );
};
